/**
 * Types frontend pour la pagination offset-based
 * Ces types sont compatibles avec les DTOs backend mais sans décorateurs NestJS
 * pour être utilisables côté frontend sans dépendre de @nestjs/swagger
 */

/**
 * Ordre de tri
 */
export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

/**
 * Constantes par défaut pour la pagination
 */
export const PAGINATION_DEFAULTS = {
  LIMIT: 20,
  PAGE: 1,
  MAX_LIMIT: 100,
} as const;

/**
 * Métadonnées de pagination pour offset-based (type frontend)
 */
export interface IOffsetPageInfo {
  /** Page actuelle (1-based) */
  page: number;
  /** Nombre d'éléments par page */
  limit: number;
  /** Nombre total d'éléments */
  totalCount: number;
  /** Nombre total de pages */
  totalPages: number;
  /** Champ de tri utilisé */
  sort: string;
  /** Ordre de tri (asc/desc) */
  order: SortOrder | string;
  /** Helper: a une page suivante */
  hasNextPage: boolean;
  /** Helper: a une page précédente */
  hasPreviousPage: boolean;
}

/**
 * Réponse de pagination offset-based (type frontend)
 */
export interface IOffsetPaginationResponse<T> {
  /** Liste des éléments de la page courante */
  data: T[];
  /** Métadonnées de pagination */
  pageInfo: IOffsetPageInfo;
}

/**
 * DTO de requête pour pagination offset-based
 */
export interface IOffsetPaginationQuery {
  /** Numéro de page (1-based) */
  page?: number;
  /** Nombre d'éléments à retourner */
  limit?: number;
  /** Champ de tri */
  sort?: string;
  /** Ordre de tri */
  order?: SortOrder;
  /** Recherche textuelle générique */
  q?: string;
}

/**
 * Helper type pour extraire les données paginées
 */
export type PaginatedData<T> = T extends IOffsetPaginationResponse<infer U> ? U : never;

// Legacy types aliases for backward compatibility
/** @deprecated Use IOffsetPageInfo instead */
export type CursorPageInfo = IOffsetPageInfo;

/** @deprecated Use IOffsetPaginationResponse instead */
export type CursorPaginationResponse<T> = IOffsetPaginationResponse<T>;

/** @deprecated Use IOffsetPaginationQuery instead */
export type CursorPaginationQueryDto = IOffsetPaginationQuery;
